"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OceanRateCardNotFoundErrorCode = void 0;
exports.OceanRateCardNotFoundErrorCode = {
    OCEAN_RATE_CARD_NOT_FOUND: 'OCEAN_RATE_CARD_NOT_FOUND'
};
//# sourceMappingURL=ocean-rate-card-not-found-error-code.js.map